<template>
    <div class="header">
        <div class="main">
            <h1 class="logo">
                <a href="/">
                    <img src="@/assets/imgs/header/logo.png" alt="羽迹科技官网" />
                </a>
                <div class="line"></div>
                <div class="zhaoshang">
                    <img src="@/assets/new-img/footer/zs.png" alt="" class="icon">
                    <div class="text">招商启航投资企业</div>
                </div>
            </h1>
            <div class="nav">
                <el-menu :default-active="activeIndex" class="nav-menu" mode="horizontal" @select="handleSelect" router>
                    <el-menu-item index="/">
                        <a href="/">首页</a>
                    </el-menu-item>

                    <el-submenu ref="sub" index="1" popper-class="poper-class1 nav-posi-top">
                        <template slot="title">
                            <div class="subtitle">
                                AI数字人
                            </div>
                        </template>
                        <el-menu-item index="carHuman">汽车数字人</el-menu-item>
                        <el-menu-item index="explainHuman">数字人讲解</el-menu-item>
                        <el-menu-item index="guideHuman">数字人导游</el-menu-item>
                        <el-menu-item index="metaHuman">元宇宙数字人</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="modelingPhone">
                        <a href="/modelingPhone">模拟仿真</a>
                    </el-menu-item>

                   
                    <el-menu-item index="aboutUs">
                        <a href="/aboutUs">企业介绍</a>
                    </el-menu-item>
                    <el-menu-item index="news">
                        <a href="/news">行业资讯</a>
                    </el-menu-item>
                </el-menu>
            </div>
            <!-- <a href="https://www.yujishishi.com/webgl/index.html" target="_blank" class="ty">
                前往体验
            </a> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeIndex: "",
        };
    },
    computed: {

        path() {
            return this.$store.state.app.path;
        },
    },
    watch: {

        path(a) {
            console.log(a);
            this.activeIndex = a;
        },
    },
    mounted() {

        this.activeIndex = this.path;

    },
    methods: {
        handleSelect(key, keyPath) {
            this.activeIndex = key;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
    },
};
</script>
<style lang="scss">
.el-menu-item.is-active {
    // color: #67d3cd;
    color: #fff !important;
}

.el-submenu.is-active .el-submenu__title {
    background: #dbf5f3 !important;
    color: #1A86FC !important;
}

.el-menu-item,
.el-submenu__title {
    // border-bottom: 0.1px solid rgb(250, 248, 248);
    // text-align: center;
}

.el-submenu.is-active .el-submenu__title {
    border-bottom-color: transparent !important;
}


.el-submenu__title i,
.el-menu--horizontal>.el-submenu .el-submenu__title {
    margin-bottom: 1px;
    color: #0B0B0C;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
    background: transparent !important;
    // backdrop-filter: brightness(110%) saturate(180%) blur(10px);
    color: #0B0B0C !important;
    // text-align: center !important;
    height: 40px !important;
    line-height: 40px !important;
    padding-left: 30px !important;
    font-size: 12px !important;
}

.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
    display: none !important;
}

.el-menu-item:last-child {
    padding-right: 0px !important;
}

.poper-class {
    margin-left: -50px;
}

.poper-class1 {
    margin-left: -20px;
}

.el-menu--horizontal>.el-menu-item {
    height: 70px !important;
}

.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    .subtitle {
        color: #1A86FC;
        position: relative;

        &::after {
            position: absolute;
            content: '';
            bottom: 0;
            width: 100%;
            height: 1px;
            left: 0;
            background: #1A86FC;
        }
    }
}

.el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 70px !important;
    line-height: 70px !important;
}

.el-submenu__title {
    position: relative;

    &:hover {
        color: #1A86FC !important;

        .subtitle {
            position: relative;
            color: #1A86FC !important;

            &::after {
                position: absolute;
                content: '';
                bottom: 0;
                width: 100%;
                height: 1px;
                left: 0;
                background: #1A86FC;
            }
        }
    }
}


.nav-posi-top {
    top: 66px !important;
    padding-bottom: 10px;
    // background: #F2F2F2 !important;

    .el-menu--popup {
        border-radius: 10px !important;
        box-shadow: none !important;
        overflow: hidden;
        min-width: 150px !important;
        background: #FFFFFF;
        padding: 0 !important;
    }

    .sub-title {
        font-size: 14px;
        color: #0B0B0C;
        font-weight: 100;
        height: 40px;
        line-height: 40px;

        background: rgba(125, 178, 255, 0.2);
        margin-bottom: 10px;
        padding-left: 30px !important;

        // padding-top: 10px !important;
        &.line {
            // border-top: 1px solid rgba(255,255,255,.2);
            margin-top: 10px;
        }
    }
}
</style>
<style lang="scss" scoped>
.header {
    width: 100%;
    position: fixed;
    z-index: 9999;
    height: 70px;
    // box-shadow: 0px 0px 10px rgba(131, 130, 130, 0.1);
    // background: rgba(9, 20, 26, 0.5);
    // backdrop-filter: brightness(110%) saturate(180%) blur(10px);
    background: #fff;
    min-width: 1280px;
    display: flex;
    justify-content: space-around;



    .main {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 1280px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;

        .nav {
            height: 70px;

            .nav-menu {
                background: transparent;
                border: 0;
                height: 70px;
            }

            .el-submenu {
                height: 70px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            a {
                color: #0B0B0C;
                display: inline-block;
                height: 70px;
                // box-sizing: border-box;
                display: flex;
                align-items: center;
                position: relative;

                &:hover {
                    color: #1A86FC;

                    &::after {
                        position: absolute;
                        content: '';
                        bottom: 0;
                        width: 100%;
                        height: 1px;
                        background: #1A86FC;
                    }
                }
            }

            .is-active a {
                color: #1A86FC;

                &::after {
                    position: absolute;
                    content: '';
                    bottom: 0;
                    width: 100%;
                    height: 1px;
                    background: #1A86FC;
                }
            }


        }

        .logo {
            display: flex;
            align-items: center;
            // width: 119px;
            // margin-left: 50px;
            height: 30px;

            a {
                width: 119px;
                height: 100%;
                display: flex;

                img {
                    width: 119px;
                    height: 100%;
                }
            }
            .line {
                height: 30px;
                width: 1px;
                background: #B3B3B3;
                margin: 0 14px;
            }
            .zhaoshang {
                display: flex;
                align-items: center;
                .icon{

                    width: 27px;
                    height: 27px;
                    
                }
                .text {
                    font-size: 14px;
                    color: #b3b3b3;
                }
            }
        }


        .ty {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 101px;
            height: 32px;
            line-height: 32px;
            background: linear-gradient(90deg, #05E5B6 0%, #1DA7FB 100%);
            border-radius: 6px;
            color: #fff;
            text-align: center;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue